var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.86719 7H3.03385V11.0833H11.2005V7H12.3672V12.25H1.86719V7ZM4.20052 5.83333L5.04635 5.03125L6.53385 6.51875V1.75H7.70052V6.51875L9.18802 5.03125L10.0339 5.83333L7.11719 8.75L4.20052 5.83333Z",
    fill: "#0A1E5A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon_download.c060b0736a3f65e97bc8eed11cf47b8e.svg";
export { ForwardRef as ReactComponent };